import styled from 'styled-components';

export const Grid = styled.section`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;
